<template>
<div class="bg-light">
  
  
  <Banner title="TrinApp"
	     pricing="true"
	     level="3"
	     bg-color="#fff"
	     class="sticky-top" />
  
  
  
  <div style="background-color: #ffb300; height: 16px;" />



  <Layout12 />



  <div style="background-color: #ffb300; height: 16px;"></div>



  <b-container
    class="text-center px-3 px-lg-5 p-5"
    fluid
    >
    <b-row>
      <b-col cols="12">
	<h1><span class="red">LaunchPad</span> - Web Application</h1>
      </b-col>
      <b-col cols="12">
	<b-img
	  :src="require('../assets/launchpad.png')"
	  class="py-4"
	  style="width: 150px;"
	  />
      </b-col>     
    </b-row>
    <b-row>
      <b-col>
	<div class="py-3 py-lg-5">
	  <p class="font-weight-bold">Open all your TrinApps using the LaunchPad Web Application</p>
	</div>
      </b-col>
    </b-row>
    <b-row class="mb-4">
      <b-col
	cols="12"
	md="3"
	offset-md="1"
	lg="3"
	offset-lg="2"
	>
	<figure>
	  <b-img
	    :src="require('../assets/trinapp_launchpad_navigation-graph.png')"
	    class="border"
	    fluid
	    />
	  <figcaption>TrinApp<sup>&trade;</sup> LaunchPad</figcaption>
	</figure>
      </b-col>
      <b-col
	cols="12"
	md="4"
	lg="3"
	>
	<p class="text-left">You can use the LaunchPad web application to run your various TrinApps on your TrinPod<sup>&trade;</sup>.</p>
      </b-col>
      <b-col
	cols="12"
	md="4"
	lg="2"
	class="text-center text-md-right"
	>
	<div class="mb-4">
	  <b-button
	    size="lg"
	    class="btn-orange"
	    href="https://trinpod.us/pricing?industry=construction"
	    >
	    Get Started
	  </b-button>
	</div>
	<div class="mb-4">
	  <b-button
	    size="lg"
	    class="btn-yellow"
	    style="width: 200px;"
	    href="https://forms.zohopublic.com/graphmetrix/form/TrinPodandTrinAppCDEEarlyAccess/formperma/GuNJp8xKOxKKLgQzWzZNpHBwr5ap857uuxKRXLHp0IM"
	    target="_blank"
	    >
	    TrinPod<sup>&trade;</sup>
	  </b-button>
	</div>
      </b-col>
    </b-row>
    <b-row class="mb-4">
      <b-col
	cols="12"
	md="7"
	offset-md="1"
	lg="6"
	offset-lg="2">
	<p class="text-left">The first TrinApps available for construction are CDE, and Crosslink with Oracle aconex Link.</p>
      </b-col>
      <b-col
	cols="12"
	md="4"
	lg="2"
	class="text-center text-md-right">
	<div class="mb-4">
	  <b-button
	    size="lg"
	    class="btn-yellow"
	    style="width: 200px;"
	    href="https://forms.zohopublic.com/graphmetrix/form/TrinPodandTrinAppCDEEarlyAccess/formperma/GuNJp8xKOxKKLgQzWzZNpHBwr5ap857uuxKRXLHp0IM"
	    target="_blank"
	    >
	    CDE
	  </b-button>
	</div>
	<div class="mb-4">
	  <b-button
	    size="lg"
	    class="btn-yellow"
	    style="width: 200px;"
	    href="https://forms.zohopublic.com/graphmetrix/form/TrinPodandTrinAppCDEEarlyAccess/formperma/GuNJp8xKOxKKLgQzWzZNpHBwr5ap857uuxKRXLHp0IM"
	    target="_blank"
	    >
	    Crosslink
	  </b-button>
	</div>
	<div class="mb-4">
	  <b-button
	    size="lg"
	    class="btn-yellow"
	    style="width: 200px;"
	    href="https://forms.zohopublic.com/graphmetrix/form/TrinPodandTrinAppCDEEarlyAccess/formperma/GuNJp8xKOxKKLgQzWzZNpHBwr5ap857uuxKRXLHp0IM"
	    target="_blank">
	    aconex Link
	  </b-button>
	</div>
      </b-col>
    </b-row>
  </b-container>



  <div style="background-color: #ffb300; height: 16px;" />


  
  <GmxFooter />


  
</div>
</template>

<script>
import GmxFooter from '@/components/footer.vue';
import Banner from '@/components/gmx-banner.vue';
import Layout12 from '@/components/layout-12.vue';
import * as log from 'loglevel'
export default {
    name: "ConstructionTrinApp",
    components: {
	Banner,
	GmxFooter,
	Layout12
    },
    methods: {
	img: function (image) {
	    require(image)
	}
    }
}
</script>

<style>
.btn.btn-outline-light:hover {
    background-color: #ff5b18;
}
</style>
